import CustomFieldType from 'constants/CustomFieldTypes'
import * as Yup from 'yup'

export function getPropertyNameFromType (type) {
  switch (type) {
    case CustomFieldType.Boolean:
      return 'bool'
    case CustomFieldType.Date:
      return 'date'
    case CustomFieldType.DateTime:
      return 'dateTime'
    case CustomFieldType.Text:
      return 'text'
    case CustomFieldType.Select:
      return 'optionId'
    default:
      alert('Unknown type property!')
      return 'unknownTypeProperty'
  }
}

function getSchemaFromDefinition (definition) {
  let schema
  switch (definition.type) {
    case CustomFieldType.Boolean:
      schema = Yup.bool()
      break
    case CustomFieldType.Date:
    case CustomFieldType.DateTime:
      schema = Yup.date().nullable()
      break
    case CustomFieldType.Text:
      schema = Yup.string()
        .max(definition.maxCharCount, 'form.validation.string.tooLong')
      break
    case CustomFieldType.Select:
      schema = Yup.string().nullable()
      break
    default:
      schema = Yup.string()
  }

  return definition.isRequired && definition.isEnabled ? schema.required('form.validation.required') : schema
}

export function mapCustomFieldsToSchema (customFields) {
  const customFieldsSchemas = customFields.map(field => ({ [field.id]: getSchemaFromDefinition(field) }))
  return Yup.object().shape({
    customFields: Yup.object().shape(Object.assign({}, ...customFieldsSchemas))
  })
}

function getInitialValueFromDefinition (definition) {
  if (definition.isEnabled) {
    switch (definition.type) {
      case CustomFieldType.Boolean:
        return false
      case CustomFieldType.Date:
      case CustomFieldType.DateTime:
      case CustomFieldType.Select:
        return null
      case CustomFieldType.Text:
      default:
        return ''
    }
  } else return undefined
}

export function mapCustomFieldsToInitialValues (customFields) {
  const customFieldsInitialValues = customFields.map(field => ({ [field.id]: getInitialValueFromDefinition(field) }))
  return ({ customFields: Object.assign({}, ...customFieldsInitialValues) })
}
